import React from 'react';
import { DNABox, DNAButton, DNAText, Iffy } from '@alucio/lux-ui';
import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors';
import { useMeetingsState } from 'src/state/context/Meetings/MeetingsStateProvider.proxy';
import { StyleSheet } from 'react-native';
import { useContent } from 'src/state/context/ContentProvider/ContentProvider.proxy';
import { Tab, tabs } from '../PresentationControls';
import { MeetingType } from '@alucio/aws-beacon-amplify/src/models';

const styles = StyleSheet.create({
  container: {
    maxHeight: 56,
    backgroundColor: colors['color-ui2-neutral-800'],
    paddingHorizontal: 24,
  },
  presentationNumber: {
    backgroundColor: colors['color-text-white'],
    borderRadius: 3,
    paddingHorizontal: 6,
    paddingVertical: 3,
  },
})

const Header = () => {
  const { presentations } = useContent();
  const {
    setCurrentTab,
    currentTab,
    togglePresentationControlsVisibility,
    meetingORM,
    endMeeting,
    checkFormDiscard,
    canEndMeeting,
  } = useMeetingsState();
  const isInPersonMeeting = meetingORM?.model.type === MeetingType.IN_PERSON;

  function onSelectTab(newTab: Tab): void {
    newTab !== currentTab && checkFormDiscard(() => { setCurrentTab(newTab) })
  }

  const handleTogglePanelVisibility = () => {
    checkFormDiscard(togglePresentationControlsVisibility)
  }

  return (
    <DNABox style={styles.container} alignY="center" fill spacing="between">
      {/* TABS */}
      <DNABox fill spacing="sm">
        {
          (Object.keys(tabs) as Tab[]).map((tabKey, idx) => {
            const isSelected = currentTab === tabKey;
            const isPresenting = presentations.length > 0;
            return (
              <DNABox key={tabs[tabKey].testID + idx}>
                <DNAButton
                  testID={`${tabs[tabKey].testID}-button-tab`}
                  appearance={isSelected ? 'filled' : 'ghost'}
                  status="secondary"
                  onPress={() => onSelectTab(tabKey as Tab)}
                  colorMode="dark"
                >
                  <DNABox spacing="sm" alignY="center">
                    {tabs[tabKey].title}
                    {
                      tabKey === 'OPENED_PRESENTATIONS' &&
                        <DNABox
                          style={[styles.presentationNumber,
                            isPresenting && { backgroundColor: colors['color-success-500'] }]}
                          alignX="center"
                          alignY="center"
                          testID="presentations-length-container"
                        >
                          <DNAText
                            colorMode={isPresenting ? 'dark' : 'light'}
                            status={isPresenting ? undefined : 'primary'}
                            testID="presentations-length"
                          >
                            {presentations.filter((p) => !p.meta).length}
                          </DNAText>
                        </DNABox>
                    }
                  </DNABox>
                </DNAButton>
              </DNABox>
            );
          })
        }
      </DNABox>
      {/* CLOSE PANEL BUTTON */}
      <Iffy is={isInPersonMeeting}>
        <DNAButton
          appearance="ghost"
          status="subtle"
          iconLeft="x"
          colorMode="dark"
          onPress={handleTogglePanelVisibility}
        />
      </Iffy>
      {/* END MEETING BUTTON */}
      <Iffy is={!isInPersonMeeting}>
        <DNAButton
          status="danger"
          onPress={endMeeting}
          disabled={!canEndMeeting}
        >
          <DNAText colorMode="dark">End</DNAText>
        </DNAButton>
      </Iffy>
    </DNABox>
  );
};

Header.displayName = 'Header';

export default Header;
